import $ from 'jquery';
import { loadPosts } from "../utils/fetch-posts";

$(function () {

  $(document).on('click', function(e) {
    if (!$(e.target).closest('.news-filter__item').length) {
      $('.news-filter__options').removeClass('news-filter__options--active');
    }
  });

  $('.news-filter__btn').on('click', function() {

    const options = $(this).siblings('.news-filter__options');

    $('.news-filter__options').not(options).removeClass('news-filter__options--active');

    $(options).toggleClass('news-filter__options--active');

  });

  $('.news-filter__option').on('click', function() {
    // Get the selected option's text
    const selectedOptionName = $(this).find('.option-name').text();

    // Find the parent item and update its filter-name
    const parentItem = $(this).closest('.news-filter__item');
    parentItem.find('.filter-name').text(selectedOptionName);

    $('.news-filter__option').removeClass('news-filter__option--active');
    $(this).addClass('news-filter__option--active');

    // Close the other options
    $('.news-filter__options').removeClass('news-filter__options--active');
  });

  // On posts load more click
  $(".js-posts-load").on("click", function () {
    const postType = $(".js-posts-load").attr("data-post-type") ?? "post";

    let region;
    $(".news-filter__item--region .news-filter__option").each(function () {
      if ($(this).hasClass("news-filter__option--active")) {
        region = $(this).attr("data-region");
        return false;
      }
    });

    let sector;
    $(".news-filter__item--sector .news-filter__option").each(function () {
      if ($(this).hasClass("news-filter__option--active")) {
        region = $(this).attr("data-sector");
        return false;
      }
    });

    console.log(region, sector);

    loadPosts({
      page: $(".js-posts-grid").attr("data-page"),
      postType,
      region,
      sector
    });
  });

  // Update posts on region change
  $(".news-filter__item--region .news-filter__option").on("click", function () {

    let data = {
      page: 1,
      postType: $(".js-posts-load-more").attr("data-post-type") ?? "post",
      replace: true,
    };

    // Check category taxonomy from posts
    if ($(this).attr("data-region")) {
      data.region = $(this).attr("data-region");
    }

    loadPosts(data);
  });

  // Update posts on sector change
  $(".news-filter__item--sector .news-filter__option").on("click", function () {

    let data = {
      page: 1,
      postType: $(".js-posts-load-more").attr("data-post-type") ?? "post",
      replace: true,
    };

    // Check category taxonomy from posts
    if ($(this).attr("data-sector")) {
      data.sector = $(this).attr("data-sector");
    }

    loadPosts(data);
  });

  // Clear filter
  $(".js-posts-reset").on("click", function () {
    $(".news-filter__option").removeClass("news-filter__option--active");

    $(".news-filter__item--region").find('.filter-name').text('Select Region...');

    $(".news-filter__item--sector").find('.filter-name').text('Select Sector...');

    let data = {
      page: 1,
      replace: true,
    };

    loadPosts(data);
  });


});

